<template>
  <div class="zy-container map wow fadeInDown" style="margin-top: 40px;">
    <TitleDesc title="倾听尔心 共生共存"
               desc="以你为中心 倾听你的心声需求  以强大的技术后盾为你服务 为你护航远行 助你乘风破浪！"/>
    <div class="customer">
    <div v-for="(item, index) in list" :key="index" class="item">
      <div class="value">
        <countTo :startVal="item.startVal" :endVal="item.endVal" :duration="2000"></countTo>{{item.value}}
      </div>
      <div class="title">
        {{item.title}}
      </div>
    </div>
    </div>
    <el-image :src="require('@/assets/images/index/map.png')" fit="scale-down" >
    </el-image>
  </div>
</template>

<script>
import TitleDesc from "@/views/index/widgets/TitleDesc.vue";
import { WOW } from "wowjs";
import countTo from "vue-count-to";

export default {
  name: "Icons",
  components: {TitleDesc, countTo},
  mounted() {
    this.$nextTick(() => {
      new WOW().init()
    })
  },
  data() {
    return {
      list: [{
        startVal: 0,
        endVal: 1000,
        value: '+',
        title: '客户品牌数'
      },
        {startVal: 0,
          endVal: 6000,
          value: '万人+',
          title: '累计用户数'
        },
        {startVal: 0,
          endVal: 1000,
          value: '亿元+',
          title: '累计销售额'
        },
        {startVal: 0,
          endVal: 99,
          value: '%',
          title: '系统稳定性'
        }
      ],

    }
  }
}
</script>

<style scoped lang="scss">
.map {
  .customer {
    display: flex;
    padding: 12px;

  }
  .item {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .value {
      font-weight: 500;
      color: #2935A7;
      font-family: Medium;
      font-size:32px;
    }

    .title {
      margin-top: 4px;
      font-size:20px;
      font-weight: 500;
      color: #4F5362;
    }
  }

}
</style>
